const TRANSLIT: Record<string, string> = {
  а: "a",  б: "b",  в: "v",  г: "g",  д: "d",  е: "e",  ё: "yo",
  ж: "zh", з: "z",  и: "i",  й: "y",  к: "k",  л: "l",  м: "m",
  н: "n",  о: "o",  п: "p",  р: "r",  с: "s",  т: "t",  у: "u",
  ф: "f",  х: "kh", ц: "ts", ч: "ch", ш: "sh", щ: "shch",
  ъ: "",   ы: "y",  ь: "",   э: "e",  ю: "yu", я: "ya",
};

export const BUSINESS_RESERVED_SLUGS = [
  "admin",
  "api",
  "app",
  "assets",
  "bot",
  "bots",
  "brand",
  "brand-icons",
  "cdn",
  "contacts",
  "cosmetology",
  "dashboard",
  "demo",
  "docs",
  "fonts",
  "help",
  "landing",
  "manicure",
  "marketing",
  "masters",
  "mini",
  "onboarding",
  "offer",
  "panel",
  "setup",
  "staging",
  "staging-api",
  "staging-masters",
  "staging-mini",
  "staging-panel",
  "staging-setup",
  "staging-superadmin",
  "superadmin",
  "support",
  "theme-previews",
  "www",
] as const;

const BUSINESS_RESERVED_SLUG_SET = new Set<string>(BUSINESS_RESERVED_SLUGS);

export function isReservedBusinessSlug(slug: string): boolean {
  return BUSINESS_RESERVED_SLUG_SET.has(slug.trim().toLowerCase());
}

export function isBusinessSlugAvailable(slug: string, exists: boolean): boolean {
  return !exists && !isReservedBusinessSlug(slug);
}

export function nameToSlug(name: string): string {
  return name
    .toLowerCase()
    .split("")
    .map((ch) => TRANSLIT[ch] ?? (ch.match(/[a-z0-9]/) ? ch : ch === " " ? "-" : ""))
    .join("")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 50);
}

export async function generateUniqueSlug(
  name: string,
  checkExists: (slug: string) => Promise<boolean>
): Promise<string> {
  const base = nameToSlug(name) || "master";
  if (!isReservedBusinessSlug(base) && !(await checkExists(base))) return base;
  for (let i = 2; i <= 99; i++) {
    const candidate = `${base}-${i}`;
    if (isReservedBusinessSlug(candidate)) continue;
    if (!(await checkExists(candidate))) return candidate;
  }
  return `${base}-${Date.now()}`;
}
